var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.963 2.5h10.074c.911 0 1.646 0 2.224.078.6.08 1.105.253 1.507.654.401.402.574.907.654 1.507.078.578.078 1.313.078 2.224v10.074c0 .911 0 1.646-.078 2.224-.08.6-.253 1.105-.654 1.507-.402.401-.907.574-1.507.654-.578.078-1.313.078-2.224.078H6.963c-.911 0-1.646 0-2.224-.078-.6-.08-1.105-.253-1.507-.654-.401-.402-.574-.907-.654-1.507-.078-.578-.078-1.313-.078-2.224V6.963c0-.911 0-1.646.078-2.224.08-.6.253-1.105.654-1.507.402-.401.907-.574 1.507-.654C5.317 2.5 6.052 2.5 6.963 2.5Zm4.384 13.165 6.527-7.333-.747-.664-5.935 6.667-3.904-2.744-.575.818 4.634 3.256Z",
    fill: "#202429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.ac99cc351d1372b30502b8587ac617aa.svg";
export { ForwardRef as ReactComponent };